module.exports = "https://files.cnvos.lb.djnd.si/static/images/clovekove-pravice.png?64d3a5697d5b9fd5970bc174a75b3ab0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/section-news-categories/clovekove-pravice.png
// module id = 120
// module chunks = 1 2